import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { globalStore } from '../../GlobalStore';
import Footer from '../../components/Footer';

const DownloadApp: React.FC = observer(() => {
  const posters = globalStore.appDownloadPosters;

  useEffect(() => {
    // 滚动到页面顶部
    window.scrollTo(0, 0);
    
    // 设置导航菜单选中状态
    globalStore.selectedMenuKey = 'download-app';
    // 强制设置为白色背景模式，模拟滚动状态
    globalStore.forceWhiteHeader = true;
    
    return () => {
      // 离开页面时重置
      globalStore.forceWhiteHeader = false;
    };
  }, []);

  const handlePrivacyClick = () => {
    // 隐私协议链接暂时为空
    console.log('隐私协议链接待实现');
  };

  return (
    <div style={{ 
      backgroundColor: '#ffffff',
      minHeight: '100vh',
      paddingTop: '60px' // 为固定的header留出空间
    }}>
      {/* 第一屏：下载APP内容 */}
      <div style={{
        minHeight: 'calc(100vh - 60px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px 20px'
      }}>
        {/* 图片区域 */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '20px',
          marginBottom: '40px'
        }}>
          {[
            { url: posters.buyerAppPosterUrl, alt: '买家APP' },
            { url: posters.sellerAppPosterUrl, alt: '卖家APP' },
            { url: posters.wechatDouyinPosterUrl, alt: '微信抖音' },
          ]
            .filter((item) => item.url)
            .map((item) => (
              <img
                key={item.alt}
                src={item.url}
                alt={item.alt}
                style={{
                  height: '70vh',
                  width: 'auto',
                  objectFit: 'contain',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                }}
              />
            ))}
        </div>

        {/* 开发者信息 */}
        <div style={{
          textAlign: 'center',
          color: '#666666',
          fontSize: '14px',
          lineHeight: '24px'
        }}>
          开发者：上海魔法向量网络有限公司 
          <a 
            href="#" 
            onClick={handlePrivacyClick}
            style={{
              color: '#1890ff',
              textDecoration: 'none',
              cursor: 'pointer',
              marginLeft: '10px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.textDecoration = 'none';
            }}
          >
            隐私协议
          </a>
        </div>
      </div>
 
    </div>
  );
});

export default DownloadApp; 